import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ENUM_MortgageExpiryType } from '@api-new/common';
import { CarouselComponent } from '@client-ui/components/carousel/carousel.component';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { VisibilityDirective } from '@shared-lib/directives/visibility.directive';
import { BrandingAssetPathPipe } from '@shared/pipes/branding-image-path.pipe';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { WidgetHeaderComponent } from '../widget-header/widget-header.component';

@Component({
  selector: 'cp-widget-remortgage-guide',
  imports: [CommonModule, RouterLink, CarouselComponent, WidgetHeaderComponent, VisibilityDirective, BrandingAssetPathPipe],
  templateUrl: './widget-remortgage-guide.component.html',
  styleUrl: './widget-remortgage-guide.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetRemortgageGuideComponent implements OnInit {
  @Input({ required: true }) propertyId: string;
  @Input({ required: true }) isCompanyBranded: boolean;
  @Input() remainingMonths: number;
  @Input() expirationStatus: ENUM_MortgageExpiryType;

  @ViewChild('bestDealVid') bestDealVid!: ElementRef;

  protected readonly globalStore = inject(Store);
  protected readonly changeDetectorRef = inject(ChangeDetectorRef);

  protected readonly ENUM_MortgageExpiryType = ENUM_MortgageExpiryType;
  protected paths = paths;
  protected playVideoTriggered = false;
  protected videoEnded = false;
  protected muted = true;

  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);

  ngOnInit(): void {
    if (this.isCompanyBranded) {
      setTimeout(() => {
        this.toggleVideoEnded(true);
        this.changeDetectorRef.markForCheck();
      }, 3000);
    }
  }

  toggleVideoEnded(videoEnded: boolean): void {
    this.videoEnded = videoEnded;
  }

  playVideo(isVisible: boolean): void {
    if (this.isCompanyBranded) return;
    if (!isVisible) return;
    if (this.videoEnded || this.playVideoTriggered) return;
    this.playVideoTriggered = true;
    setTimeout(() => this.bestDealVid?.nativeElement?.play(), 500);
  }
}
